import { PageDataSettings } from "./initPageDataSettings.js";

export function getPageName() {
  const { Server, UrlData } = PageDataSettings;
  return `${Server}/${(UrlData.PagePath === "" ? "home" : UrlData.PagePath)}`;
}